module.exports = __webpack_public_path__ + "img/news_01.03968043.jpg";